import React, { useContext } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { BsFacebook, BsInstagram, BsLinkedin } from 'react-icons/bs'
import { ChatContext } from '@/pages/_app'
import Subscribe from '@/components/common/subscribe'

const FaqAndInfo = () => {
  const toggleChat = useContext(ChatContext)

  return (
    <>
      <Subscribe />
      <div className="flex flex-wrap justify-center text-gray-600 bg-custom-gray-50">
        <div className="uta-container">
          <div className="flex flex-wrap mt-2 md:flex-row">
            <div className="flex flex-wrap justify-between w-full mt-5">
              <div className="grid gap-0 sm:gap-8 md:gap-8 lg:gap-5 sm:flex maxSm:mb-2 maxLg:basis-[100%]">
                {infoList?.map((item, index) => (
                  <p
                    key={index}
                    className="text-lg sm:text-sm md:text-lg font-medium tracking-wide text-white"
                  >
                    {!item.isLink ? (
                      <>
                        <Link href="tel:+1 (212) 645-4200" className="sm:hidden" legacyBehavior>
                          <a
                            className="leading-[50px] no-underline hover:underline sm:hidden"
                            target={item.target || '_blank'}
                          >
                            {item.name}
                          </a>
                        </Link>
                        <div className="py-3 hidden sm:block">{item.name}</div>
                      </>
                    ) : item.url ? (
                      <Link href={item.url} legacyBehavior>
                        <a
                          className="leading-[50px] hover:underline"
                          target={item.target || '_blank'}
                        >
                          {item.name}
                        </a>
                      </Link>
                    ) : (
                      <Link scroll={false} href={''} legacyBehavior>
                        <a
                          className={`${
                            item.isChat && 'cursor-pointer'
                          } leading-[50px] hover:underline`}
                        >
                          <div>{item.name}</div>
                        </a>
                      </Link>
                    )}
                  </p>
                ))}
              </div>

              <div className="lg:mt-[12px]">
                <span className="inline-flex justify-center pb-3 space-x-8 lg:space-x-8 sm:space-x-10 sm:justify-start">
                  <Link href="https://www.linkedin.com/company/uta-speakers" legacyBehavior>
                    <a
                      className="text-2xl text-custom-gray-100 hover:text-white hover:opacity-100"
                      target="_blank"
                      aria-label="United talent agency on LinkedIn"
                    >
                      <BsLinkedin />
                    </a>
                  </Link>
                  <Link href="https://www.instagram.com/utaspeakers/" legacyBehavior>
                    <a
                      className="text-2xl text-custom-gray-100 hover:text-white hover:opacity-100"
                      target="_blank"
                      aria-label="United talent agency on Instagram"
                    >
                      <BsInstagram />
                    </a>
                  </Link>
                  <Link href="https://twitter.com/utaspeakers" legacyBehavior>
                    <a
                      className="text-2xl text-custom-gray-100 hover:text-white hover:opacity-100"
                      target="_blank"
                      aria-label="United talent agency on Twitter"
                    >
                      <Image
                        src="/static/icons/twitterFooter.svg"
                        height={24}
                        width={24}
                        alt="Twitter"
                        className="text-custom-gray-100 opacity-50 hover:text-white hover:opacity-100"
                      />
                    </a>
                  </Link>
                  <Link href="https://facebook.com/utaspeakers" legacyBehavior>
                    <a
                      className="text-2xl text-custom-gray-100 hover:text-white hover:opacity-100"
                      target="_blank"
                      aria-label="United talent agency on Facebook"
                    >
                      <BsFacebook />
                    </a>
                  </Link>
                </span>
              </div>
            </div>
            <div className="flex flex-wrap lg:flex-row justify-between w-full mt-2">
              <footer className="mb-8 flex gap-1 flex-col flex-wrap sm:flex-row sm:justify-start w-full lg:w-[65%] xl:w-[71.666667%]">
                {footerLinks.map((item, index, arr) => (
                  <div className="flex flex-row md:mt-0 lg:mt-0" key={index}>
                    {item.url ? (
                      <div className="md:mb-0">
                        <Link href={item.url} legacyBehavior>
                          <a
                            className="leading-8 text-xs font-medium uppercase hover:border-b text-custom-gray-60 hover:text-white"
                            target="_blank"
                          >
                            {item.name}
                          </a>
                        </Link>
                      </div>
                    ) : (
                      <div className="md:mb-0">
                        <a className="leading-8 xs:ml-0.5 text-xs font-medium uppercase text-custom-gray-60">
                          {item.name}
                        </a>
                      </div>
                    )}
                    <div className="pt-1 pl-2 text-custom-gray-60 text-sx xs:block">
                      {index !== arr.length - 1 && (
                        <hr className="text-xs rotate-90 w-2.5 mt-2.5" />
                      )}
                    </div>
                  </div>
                ))}
              </footer>
              <div className="xs:mb-16 maxSm:mb-4">
                <p className="mt-6 text-xs font-medium uppercase maxSm:mt-2 text-custom-gray-60 xs:mt-0 md:px-0 md:hidden lg:hidden xl:hidden 2xl:hidden">
                  &#169; {new Date().getFullYear()} United Talent Rights Reserved.
                </p>
                <p className="mt-3 text-xs font-medium uppercase text-custom-gray-60 md:hidden lg:hidden xs:px-0 xs:left-0">
                  &nbsp;VERSION {process.env.NEXT_PUBLIC_VERSION_NUMBER}
                </p>
              </div>
              <div className="flex flex-row items-center hidden mr-0 lg:ml-6 xl:mr-1 md:block lg:block xl:block 2xl:block">
                <div className="relative mt-1 mb-4">
                  <p className="xl:px-2 mt-1 text-xs font-medium uppercase text-custom-gray-60 md:pr-1">
                    &#169; {new Date().getFullYear()} United Talent Rights Reserved.
                  </p>
                  <p className="xl:px-2 mt-3 text-xs font-medium uppercase text-custom-gray-60 md:pr-1 lg:float-right">
                    VERSION {process.env.NEXT_PUBLIC_VERSION_NUMBER}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FaqAndInfo

const infoList = [
  { name: 'About UTA', url: 'https://www.unitedtalent.com/about/', isLink: true },
  { name: 'Call Us: (212) 645-4200', url: null, isLink: false },
  // { name: 'Chat Now', url: null, isChat: true, isLink: true },
  { name: 'Get In Contact', url: '/contact', target: '_self', isLink: true },
  // { name: 'Faq', url: '/faq', target: '_self', isLink: true },
]

const footerLinks = [
  { name: 'Terms & Conditions', url: 'https://www.unitedtalent.com/terms/' },
  { name: 'Privacy Policy', url: 'https://www.unitedtalent.com/privacy-policy' },
  { name: 'Client Privacy Policy', url: 'https://www.unitedtalent.com/client-privacy-policy' },
  {
    name: 'NY LICENSE 2077290-DCA',
    url: null,
  },
  {
    name: 'CA LICENSE TA000250981',
    url: null,
  },
]